import getQueryParamValue from "src/utilities/getQueryParamValue";
import noticeError from "src/app/utilities/noticeError";

export const getUserContext = async () => {
  const shop = getQueryParamValue("va-shop") || "asos";

  try {
    const webContext = window?.asos?.webContext;
    const identity = window?.asos?.sdk?.identity;
    const customer = identity?.customer;
    const isAuthenticated = (await customer?.isAuthenticated()) || false;
    const country = webContext?.getBrowseCountry();
    const language = webContext?.getBrowseLanguage();
    const store = webContext?.getStoreId();
    const customerId = await customer?.customerId();
    const firstName = await customer?.firstName();
    const lastName = await customer?.lastName();
    const accessToken = isAuthenticated ? await identity?.getAccessToken() : "";

    return {
      shop,
      country,
      language,
      store,
      isAuthenticated,
      customerId,
      firstName: isAuthenticated ? firstName : "",
      lastName: isAuthenticated ? lastName : "",
      accessToken: isAuthenticated ? accessToken : "",
    };
  } catch (error) {
    noticeError(error);
  }

  return {};
};
